<template>
	<div>
		<v-btn
			id="botaoAdicionar"
			:type="type"
			class="text-capitalize"
			:disabled="desabilitar"
			depressed
			color="primary"
			min-width="100"
			:loading="loading"
			:min-height="altura"
			@click="$emit('adicionar')"
		>
			<slot name="label">
				{{ label }}
			</slot>
		</v-btn>
	</div>
</template>

<script>
export default {
	name: 'botao-adicionar',
	props: {
		altura: {
			type: Number,
			default: 20,
		},
		desabilitar: {
			type: Boolean,
		},
		label: {
			type: String,
			default: 'Adicionar',
		},
		loading: {
			type: Boolean,
		},
		type: {
			type: String,
			default: 'submit',
		},
	},
}
</script>

<style lang="stylus">
@media (max-width 720px)
	.botao-adicionar
		justify-content center
		padding-top 25px
</style>
